module.exports = __webpack_public_path__ + "static/img/6.a1b96aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/6.png
// module id = dZ8G
// module chunks = 0